import loc from "owa-localize";
import { messageSize_MB, messageSize_KB } from "./formatMessageSize.locstring.json";

const BYTES_PER_KB = 1024;
const BYTES_PER_MB = 1024 * 1024;

/**
 * Formats a message size in bytes for size sorted content column.
 * If the size is less than 1 MB, displays in KB; otherwise displays in MB.
 * @param sizeBytes - Size in bytes, or null/undefined
 * @returns Formatted string like "256 KB" or "3 MB"
 */
export default function formatMessageSize(sizeBytes: number | null | undefined): string {
    if (sizeBytes === null || sizeBytes === undefined) {
        return "N/A";
    }
    
    if (sizeBytes < BYTES_PER_MB) {
        const kb = Math.round(sizeBytes / BYTES_PER_KB);
        return `${kb} ${loc(messageSize_KB)}`;
    }
    
    const mb = Math.round(sizeBytes / BYTES_PER_MB);
    return `${mb} ${loc(messageSize_MB)}`;
}
